
import { useContext, useEffect, useState } from 'react';
import "./style/login.css";
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../../contextApi/ContextApi';
import SignInput from './signComponents/SignInput';
import { SignContext } from '../../../contextApi/SignContext';
import Cookies from '../../Cookies';


export default function Login() {
  const { setCurrentManager, setConnectedManager, setCategoryNow, setCurrentWebsite, setCurrentManagerUID, cookiesApprooved, setToastMessage, messagesOptions, toastMessage } = useContext(AppContext);
    const { login, setLoginEmail, setLoginPass, loginFlag} = useContext(SignContext);
    const nav = useNavigate();
    const [alertFlag, setAlertFlag] = useState(false);
    useEffect(()=>{
      if(!toastMessage || toastMessage==="")return;
      if(toastMessage === "לא נמצא משתמש עם הפרטים שהוזנו"){
        setAlertFlag(true);
        setTimeout(() => {
          setAlertFlag(false);
        }, 20000);
      }
    },[toastMessage])
    return (
      <div className='login_container' dir='rtl'>
          <form className="login_form" onSubmit={(e)=>{e.preventDefault(); login(nav, setCurrentWebsite, setConnectedManager, setCategoryNow, setCurrentManager, setCurrentManagerUID, setToastMessage, messagesOptions)}}>
              <div className="login_form_inputsDiv">
                  <SignInput _class={"loginInput"} autoComplete={"username"} id={"login_email"} label={"אימייל :"} type={"text"} placeholder={"לדוגמא: myName@mail.com"} setState={setLoginEmail}/>
                  <SignInput _class={"loginInput"} autoComplete={"current-password"} id={"login_password"} label={"סיסמא :"} type={"password"} placeholder={"לדוגמא: SomeP@$$w0rd123"} setState={setLoginPass}/>
              </div>
              <div className='login_problem'>
                {alertFlag ? <div className='userNotFoundAlert' dir='rtl'>
                <p>{"היי, לצערנו לא מצאנו את המשתמש שלך"}</p>  
                <p>{"מומלץ לבדוק תחילה שהוזנו פרטי התחברות נכונים."}</p>  
                <p>{"אם לא נרשמת עדיין, ניתן לעבור לעמוד ההרשמה בלינק בתחתית המסך."}</p>  
                <p>{"במידה והשגיאה חוזרת על עצמה או שלדעתך חלה טעות,"}</p>  
                <p>{"ניתן ליצור קשר עם התמיכה שלנו:"}</p>  
                <p>{"whatsapp - 0507170101"}</p>  
                <p>{"email - webingo.company@gmail.com"}</p>  
                <p>{"אנו מודים לך על ההבנה"}</p>  
              </div> : null}
              </div>
              <div className='login_btnDiv'>
                <button type='submit' className='login_btn'>{loginFlag ? "טוען..." : "התחבר"}</button>
              </div>
          </form>
          <a className='login_signupButton' href='/'>עדיין אין לי משתמש</a>
          {!cookiesApprooved ? <Cookies/> : null}
      </div>
    )
}
